export enum InmarDisposition {
  WIP = "WIP",
  DONATE = "DONATE",
  // cspell:disable-next-line
  DESTROY_ON = "DESTROYON",
  LIQUIDATE = "LIQUIDATE",
  RTV = "RTV",
  HOLD = "HOLD",
  DESTROY_OFF = "DESTROYOFF",
  // cspell:disable-next-line
  RTNCLN = "RTNCLN",
  DESTROY_IN_FIELD = "DESTROYINFIELD",
  // cspell:disable-next-line
  RTNCLNHAZ = "RTNCLNHAZ",
  RTS = "RTS",
}

export const InmarDispositionDisplayText = {
  [InmarDisposition.WIP]: "Work in Progress",
  [InmarDisposition.DONATE]: "Donation or 2nd Quality Item",
  [InmarDisposition.DESTROY_ON]: "Destroy at Facility",
  // cspell:disable-next-line
  [InmarDisposition.LIQUIDATE]: "Remarketing Market",
  [InmarDisposition.RTV]: "Return to Vendor",
  [InmarDisposition.HOLD]: "Hold for Inventory",
  [InmarDisposition.DESTROY_OFF]: "Destroy at Destruction Facility (HAZ)",
  // cspell:disable-next-line
  [InmarDisposition.RTNCLN]: "Return to Client",
  [InmarDisposition.DESTROY_IN_FIELD]: "Destroy in Field",
  // cspell:disable-next-line
  [InmarDisposition.RTNCLNHAZ]: "Return Hazardous Item to Client",
  [InmarDisposition.RTS]: "Return to Stock",
} as const;
